<template>
  <v-layout wrap justify-center align-center>
    <v-flex xs4 md5><v-divider></v-divider></v-flex>
    <v-flex xs4 md2 text-xs-center title font-weight-light>{{text}}</v-flex>
    <v-flex xs4 md5><v-divider></v-divider></v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "ProfileSubTittle",
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>